module.exports = {
  addToRegistryGuest: {
    noSignInText: 'Please sign in to add items to your registry.',
    signInCTA: 'Sign In',
    createRegistryCTA: 'Create A Registry',
    linkRegistryText: 'Created a registry in store?',
    linkRegistryCTA: 'Start Here',
  },
  addToRegistry: {
    noSignInText: "We Can't find a registry associated with your account.",
    createRegistryCTA: 'Create A Registry',
    linkRegistryText: 'Created a registry in store?',
    linkRegistryCTA: 'Start Here',
  },
  addToMultipleRegistry: {
    successMsg: '1 item added to',
    errorMsg:
      'The system cannot currently add this item to your registry. Please try again later.',
    viewRegistryCTA: 'View Registry',
    continueShoppingCTA: 'Continue Shopping',
    selectRegistryMsg: 'Select a Registry',
  },
  addToUsersRegistry: {
    successMsg: '1 item added to',
    errorMsg:
      'The system cannot currently add this item to your registry. Please try again later.',
    viewRegistryCTA: 'View Registry',
    continueShoppingCTA: 'Continue Shopping',
  },
};
